module.exports = __webpack_public_path__ + "assets/clever-media.f7f08188b73c6d08035411e721a2ceb1980a48be93984376a67c32ff99812b3f.png";